<template>
    <div class="slider dynamic" :style="{ width: opened ? '200px' : '64px' }">
        <div class="sidebar">
            <div class="logo">
                <img ref="logoImgRef" src="../assets/logo.jpg" />
                <h4>起重优品系统</h4>
            </div>
            <el-menu
                @select="handleSelect"
                :unique-opened="true"
                :collapse-transition="true"
                :collapse="!opened"
                mode="vertical"
                :default-active="defaultPath"
                class="menu"
            >
                <template v-for="(menu, i) in menuList" :key="'i' + i">
                    <el-menu-item :index="menu.url">
                        <i class="fas" :class="[menu.icon]" v-if="menu.icon"></i>
                        <template #title>{{ menu.name }}</template>
                    </el-menu-item>
                </template>
            </el-menu>
        </div>
        <div class="shrinkage">
            <div class="shrinkage-icon" @click="toggleClick">
                <i :class="['fas', !opened ? 'fa-indent' : 'fa-outdent', 'collapse']"></i>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { userLevel } from '@/commons/utils';
const currentUserLevel = userLevel();
const store = useStore();
const router = useRouter();
const route = useRoute();
const menuList = [];

if (currentUserLevel === 0) {
    menuList.push({
        url: '/admin/user/list',
        name: '用户管理'
    });
    menuList.push({
        url: '/admin/menus/list',
        name: '手册分类'
    });
    menuList.push({
        url: '/admin/sale-nets/list',
        name: '销售网络'
    });
    menuList.push({
        url: '/admin/corperates/list',
        name: '合作商管理'
    });
    menuList.push({
        url: '/admin/global/config',
        name: '全局配置'
    });
    menuList.push({
        url: '/admin/quotes-config/list',
        name: '选型手册'
    });
    menuList.push({
        url: '/admin/coupons/list',
        name: '代金券优惠券'
    });
    menuList.push({
        url: '/admin/global/pc',
        name: 'PC全局配置'
    });
}
function handleSelect(index) {
    router.push(index);
}
// 默认的路径函数
const defaultPath = ref(route.path);
// 点击
const opened = computed(() => store.state.app.sidebar.opened);
const toggleClick = function () {
    store.dispatch('app/toggleSideBar');
};
</script>
<style lang="scss">
.shrinkage {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    height: 56px;
    background-color: #262f3e;

    &-icon {
        display: flex;
        align-items: center;
        width: 64px;
        height: 100%;
        &:hover {
            background-color: #344258;
            i {
                color: #ffffff;
            }
        }
    }

    .collapse {
        font-size: 18px;
        margin-left: 20px;
        cursor: pointer;
        color: #666666;
    }
}
</style>
